module.exports = __webpack_public_path__ + "static/img/guide-36.1035dc66.png";